import React from "react"
import { ThemeSettings } from "./utils/theme-settings"
import { NoSettings } from "./utils/no-settings"
import { useParentSection } from "../../section/utils/use-parent-section"

export function ParagraphSettings({ block_id }) {
  const section = useParentSection(block_id)

  if (!section) return <NoSettings />

  return <ThemeSettings type="paragraph" section={section} showLinkColor />
}
